var cibHulu = ["32 32", "<path d='M19.197 9.807h-4.807c-0.943 0.016-1.875 0.199-2.751 0.543v-10.391h-7.719v32.083h7.729v-12.681c-0.067-1.204 0.876-2.229 2.084-2.267h4.52c1.152 0 2.095 0.923 2.12 2.079v12.787h7.704v-13.907c0-5.88-3-8.213-7.865-8.213z'/>"];

export { cibHulu };
//# sourceMappingURL=cib-hulu.js.map
